import type { TTripTaskForCargoReq } from 'api/swagger';
import type { TCargoTaskState } from 'shared/stores/use-cargo-task-store';
import { ELocationMode } from 'types/location';
import { ETripTaskType } from 'types/trips';

export const isWarehouseOnlyType = (type: ETripTaskType) =>
  type === ETripTaskType.loading_wh || type === ETripTaskType.unloading_wh;

export const isReloadingType = (type: ETripTaskType) =>
  type === ETripTaskType.reloading_from || type === ETripTaskType.reloading_to;

export const isAutoAddressAllowed = (type: ETripTaskType) =>
  type === ETripTaskType.loading || type === ETripTaskType.unloading;

export const needLocationForm = (type: ETripTaskType) => !isWarehouseOnlyType(type);

export const needWarehouseSelect = (type: ETripTaskType) => isWarehouseOnlyType(type) || isReloadingType(type);

export const LOADING_TASK_TYPES = [ETripTaskType.loading, ETripTaskType.loading_wh, ETripTaskType.reloading_to];

export const UNLOADING_TASK_TYPES = [ETripTaskType.unloading, ETripTaskType.unloading_wh, ETripTaskType.reloading_from];

export const validateCargoTask = (state: TCargoTaskState) => {
  const { taskType, locationMode, coordinates, address, warehouseId } = state;

  if (!taskType) return false;

  if (needWarehouseSelect(taskType) && !warehouseId) return false;

  if (!isWarehouseOnlyType(taskType)) {
    if (locationMode === ELocationMode.coordinates) {
      return coordinates.lat !== undefined && coordinates.lng !== undefined;
    }
    return !!address.countryId && !!address.city && !!address.address;
  }

  return true;
};

export const buildCargoTask = (state: TCargoTaskState): TTripTaskForCargoReq => {
  const { taskType, locationMode, coordinates, address, warehouseId } = state;

  const task: TTripTaskForCargoReq = { type: taskType as ETripTaskType };

  if (taskType && needWarehouseSelect(taskType)) {
    task.warehouseId = warehouseId;
  }

  if (taskType && !isWarehouseOnlyType(taskType)) {
    if (locationMode === ELocationMode.fromCargo) {
      task.autoAddress = 'cargo';
    } else if (locationMode === ELocationMode.coordinates && coordinates.lat && coordinates.lng) {
      task.coordinates = { lat: coordinates.lat, lng: coordinates.lng };
    } else {
      task.address = {
        countryId: address.countryId!,
        name: address.name || '',
        postCode: address.postCode || '',
        city: address.city || '',
        address: address.address || '',
      };
    }
  }

  return task;
};
